// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"bc89daad","239":"6611dd46"}[chunkId] + ".chunk.js";
};